import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import {
  validateDate,
  validateDateAfterToday,
  validateDateBeforeToday,
  validateDateIsOneOfThisWeekDays,
} from 'utils/validation/validators'

export const dynamicDateValidators = (date: string, question: CustomFormQuestion): string => {
  let error = ''

  if (question?.validation) {
    if (question?.validation?.date_must_be_later) {
      if (!validateDateAfterToday(date)) {
        error = 'A data deve ser posterior a atual'
      }
    }

    if (question?.validation?.date_must_be_previous) {
      if (!validateDateBeforeToday(date)) {
        error = 'A data deve ser anterior a atual'
      }
    }

    if (question?.validation?.date_must_be_this_week_days) {
      if (question?.validation?.date_must_be_this_week_days.length > 0) {
        if (!validateDateIsOneOfThisWeekDays(date, question?.validation?.date_must_be_this_week_days)) {
          error = `Dias da semana permitidos: ${question?.validation?.date_must_be_this_week_days}`
        }
      }
    }
  }

  return error
}

type ValidateDateOnCustomFormParams = {
  date: string
  question: CustomFormQuestion
}

export default function validateDateOnCustomForm({ date, question }: ValidateDateOnCustomFormParams) {
  let error = ''
  if (question.is_required && !date) {
    error = 'Este campo é obrigatório'
  }
  if (date) {
    if (!validateDate(date)) {
      error = 'A data está inválida'
    }
    const errorMessage = dynamicDateValidators(date, question)
    if (errorMessage !== '') error = errorMessage
  }
  return error
}
